import { Route, Routes } from 'react-router-dom'
import Home from './pages/Home.jsx'
import Sign from './pages/Sign.jsx'
import { ThemeProvider } from './providers/ThemeProvider.jsx'
import { SSEProvider } from './contexts/SSEContext.jsx'
import { useInitCheckoutSession } from './system/checkoutSession.js'

export default function App() {
  useInitCheckoutSession()

  return (
    <ThemeProvider>
      <SSEProvider>
        <Routes>
          <Route path="/sign/*" element={<Sign />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </SSEProvider>
    </ThemeProvider>
  )
}
